/**
 * @description 參數 ID (enum)
 */
export enum SystemParamIdEnum {
  /** 文件 Base URL */
  DocURL = 'docUrl',
  /** 閒置過久跳窗時間 (秒) */
  Idle = 'idle',
  /** 閒置後倒數登出時間 (秒) */
  Reciprocal = 'reciprocal',
  /** 旅遊險最久可選生效日 (天) */
  StartMax = 'StartMax',
  /** 國內旅遊最大投保天數 (天) */
  DomesticMax = 'DomesticMax',
  /** 國外旅遊最大投保天數 (天) */
  ForeignMax = 'ForeignMax',
  /** Captcha 音檔 Url */
  AudioUrl = 'AudioUrl'
}
